import * as React from 'react';

import TabHeader from '../../../common/components/TabHeader';
import { useGreeting } from '../../hooks/useGreeting';

export const HomeHeader = () => {
    return null;
};

export const HomeHeaderNavbar = () => {
    const { greeting } = useGreeting();
    return (
        <TabHeader headerTitle={greeting} headerHomeContext="headerNavbar" />
    );
};

export const HomeTopNavbar = () => {
    const { greeting } = useGreeting();
    return <TabHeader headerTitle={greeting} headerHomeContext="topNavbar" />;
};
